import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  CarFigure,
  IllustrationSvg,
  MotionLines,
  SkyBackdrop,
  SlopeSurface,
} from './shared';

export default function CarEasyIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.easy;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Araç rahat çıkıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={44} endY={36} accent={accent} />
      <CarFigure cx={46} cy={28} tilt={-6} primary={primaryColor} />
      <MotionLines x={30} y={32} count={2} />
    </IllustrationSvg>
  );
}
